export default {"src":"/_next/static/media/section-blank.3995abff.svg","height":40,"width":40};